import { render, staticRenderFns } from "./addTrainerTrainee.vue?vue&type=template&id=c3fb812c&scoped=true"
import script from "./addTrainerTrainee.vue?vue&type=script&lang=ts"
export * from "./addTrainerTrainee.vue?vue&type=script&lang=ts"
import style0 from "./addTrainerTrainee.vue?vue&type=style&index=0&id=c3fb812c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb812c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3fb812c')) {
      api.createRecord('c3fb812c', component.options)
    } else {
      api.reload('c3fb812c', component.options)
    }
    module.hot.accept("./addTrainerTrainee.vue?vue&type=template&id=c3fb812c&scoped=true", function () {
      api.rerender('c3fb812c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobility/addTrainerTrainee.vue"
export default component.exports